<template>
  <custom-dialog class="add-pay-info-public-step2-dialog" :title="model.title" width="900px" :visible="visible" v-on="$listeners">
    <div class="dialog-body" style="padding-top: 0 !important">
      <div class="content">
        <div class="l">
          <div class="group">
            <div class="title">{{ $t('apip_step21_zzxx') }}</div>
            <div class="info">
              <el-form label-position="top" :model="form" :rules="rules" :validate-on-rule-change="false" ref="form">
                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item :label="$t('apip_step21_shou_kuan_fang')">
                      <el-input v-model="form.sellerName" :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('apip_step21_skfzh')" prop="sellerAccount" class="row">
                      <div class="item" v-if="isEdit">
                        <div class="label" @click="toChangeField">{{ $t('apip_step21_geng_gai') }}</div>
                      </div>
                      <custom-select
                        v-if="dicCodeName.bank_branch"
                        v-model="form.sellerAccount"
                        url="PartnerBankcardListByOrgId"
                        :params="{ orgId: receivableOrgId }"
                        :props="{ label: 'label', value: 'depositNumber' }"
                        @getList="onSellerAccountGetList"
                        :dataFilter="bankListFilter"
                        :disabled="isEdit"
                      ></custom-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item :label="$t('apip_step21_fu_kuan_fang')" prop="buyerName">
                      <el-input v-model="form.buyerName" :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('apip_step21_fkfzh')" prop="buyerAccount" class="row">
                      <div class="item" v-if="!!transactionReceipt.length">
                        <div class="label" @click="toChangeField">{{ $t('apip_step21_geng_gai_1') }}</div>
                      </div>
                      <custom-select
                        v-if="dicCodeName.bank_branch"
                        v-model="form.buyerAccount"
                        url="PartnerBankcardListByOrgId"
                        :params="{ orgId: payableOrgId }"
                        :props="{ label: 'label', value: 'depositNumber' }"
                        @getList="onBuyerAccountGetList"
                        :dataFilter="bankListFilter"
                        ref="bank"
                        :clearable="false"
                        :disabled="!!transactionReceipt.length"
                      ></custom-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item :label="$t('apip_step21_fu_kuan_ri_qi')" prop="tradeFinishTime" class="row">
                      <div class="item" v-if="!!transactionReceipt.length">
                        <div class="label" @click="toChangeField">{{ $t('apip_step21_geng_gai_2') }}</div>
                      </div>
                      <custom-date-picker
                        v-model="form.tradeFinishTime"
                        :picker-options="beforeToday"
                        type="date"
                        style="width: 100%"
                        :disabled="!!form.tradeFinishTime && !!transactionReceipt.length"
                        :clearable="false"
                        value-format="YYYY-MM-DD HH:mm:ss"
                      ></custom-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('apip_step21_fu_kuan_jin_e_1')" prop="totalAmount" class="row">
                      <div class="item" v-if="isEdit">
                        <div class="label" @click="toChangeField">{{ $t('apip_step21_geng_gai_3') }}</div>
                      </div>
                      <el-input v-model="form.totalAmount" type="number" :disabled="isEdit"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="24">
                    <el-form-item :label="$t('apip_step21_fu_kuan_hui_zhi')">
                      <t-upload
                        ref="transactionReceipt"
                        :limit="1"
                        :bizId="bizId"
                        :bizType="bizType"
                        v-model="transactionReceipt"
                        :autoUpload="false"
                        type="dragFile"
                        accept="image/*"
                        :isKeepValue="true"
                      ></t-upload>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
        <div class="r">
          <div class="info-preview">
            <div class="title">{{ $t('apip_step21_xin_xi_yu_lan') }}</div>
            <div class="list">
              <div class="item">
                <div class="key">{{ $t('apip_step21_zhmc') }}:</div>
                <div class="val">{{ copyInfo.accountName }}</div>
              </div>
              <div class="item">
                <div class="key">{{ $t('apip_step21_yhzh') }}:</div>
                <div class="val">{{ copyInfo.account }}</div>
              </div>
              <div class="item">
                <div class="key">{{ $t('apip_step21_kai_hu_yin_hang') }}:</div>
                <div class="val">{{ copyInfo.bank }}</div>
              </div>
              <div class="item">
                <div class="key">{{ $t('apip_step21_zzbz') }}:</div>
                <div class="val">
                  {{ copyInfo.remark }}
                  <span class="tips">(*{{ $t('apip_step21_dksqbz') }})</span>
                </div>
              </div>
            </div>

            <div class="amount">
              <div class="key">{{ $t('apip_step21_fu_kuan_jin_e') }}:</div>
              <div class="val">￥{{ form.totalAmount }}</div>
            </div>

            <el-button type="info" class="copy" @click="onCopy">
              <i class="icon icon-fuzhi"></i>
              <span>{{ $t('apip_step21_fu_zhi') }}</span>
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" plain @click="closeDialog">{{ $t('com_cancel') }}</el-button>
      <el-button type="warning" @click="onConfirm">{{ $t('com_confirm') }}</el-button>
    </div>
    <bank-card-dialog v-if="addBankVisible" @close="addBankVisible = false" :model="addBankModel" @success="onAddBankSuccess"></bank-card-dialog>
    <update-pay-info-field-dialog
      v-if="updateFiledsVisible"
      @close="updateFiledsVisible = false"
      :model="updateFiledsModal"
      :auth="updateFileds"
      :payableOrgId="payableOrgId"
      :receivableOrgId="receivableOrgId"
      @confirm="onUpdateFieldConfirm"
    ></update-pay-info-field-dialog>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import tUpload from '@/components/upload.vue';
import bankCardDialog from './bank_card_dialog.vue';
import updatePayInfoFieldDialog from './update_pay_info_filed_dialog.vue';

// apip_step21_zzxx: 转账信息// apip_step21_geng_gai: 更改// apip_step21_geng_gai_1: 更改// apip_step21_geng_gai_2: 更改// apip_step21_geng_gai_3: 更改// apip_step21_xin_xi_yu_lan: 信息预览// apip_step21_zhmc: 账户名称// apip_step21_yhzh: 银行账号// apip_step21_kai_hu_yin_hang: 开户银行// apip_step21_zzbz: 转账备注// apip_step21_dksqbz: 打款时请备注// apip_step21_fu_kuan_jin_e: 付款金额// apip_step21_fu_zhi: 复制// apip_step21_shou_kuan_fang: 收款方// apip_step21_skfzh: 收款方账户// apip_step21_fu_kuan_fang: 付款方// apip_step21_fkfzh: 付款方账户// apip_step21_fu_kuan_ri_qi: 付款日期// apip_step21_fu_kuan_jin_e_1: 付款金额// apip_step21_fu_kuan_hui_zhi: 付款回执// apip_step21_xin_xi_geng_gai: 信息更改// apip_step21_zhmc_1: 账户名称：// apip_step21_yhzh_1: 银行账户：// apip_step21_kai_hu_hang: 开户行：// apip_step21_zzbz_1: 转账备注：// apip_step21_xzyh: 新增银行

export default {
  name: 'addPayInfoPublicStep2Dialog',
  mixins: [dialogMixins],
  props: {
    orderNum: [Number, String],
    totalAmount: [Number, String],
    // 付款信息列表长度
    listLen: {
      type: Number,
      default: 0,
    },
    paymentCode: [Number, String],
  },
  components: {
    tUpload,
    bankCardDialog,
    updatePayInfoFieldDialog,
  },
  computed: {
    rules() {
      return {
        sellerName: { required: true, message: this.$t('com_required') },
        sellerAccount: [{ required: true, message: this.$t('com_required') }, { max: 20 }],
        tradeMethod: { required: true, message: this.$t('com_required') },
        buyerName: { required: true, message: this.$t('com_required') },
        buyerAccount: [{ required: true, message: this.$t('com_required') }, { max: 20 }],
        totalAmount: { required: true, message: this.$t('com_required'), type: 'string' },
        tradeFinishTime: { required: true, message: this.$t('com_required') },
      };
    },
    bizId() {
      return this.form.tradeId;
    },
    receivableOrgId() {
      const outerItem = this.model.data && this.model.data.outerItem ? this.model.data.outerItem : {};
      return this.model.type === 'add' ? outerItem.receivableOrgId : this.model.data.form.sellerId;
    },
    payableOrgId() {
      const outerItem = this.model.data && this.model.data.outerItem ? this.model.data.outerItem : {};
      return this.model.type === 'add' ? outerItem.payableOrgId : this.model.data.form.buyerId;
    },
    buyerName() {
      const outerItem = this.model.data && this.model.data.outerItem ? this.model.data.outerItem : {};
      return this.model.type === 'add' ? outerItem.payableOrgName : this.model.data.form.buyerName;
    },
    sellerName() {
      const outerItem = this.model.data && this.model.data.outerItem ? this.model.data.outerItem : {};
      return this.model.type === 'add' ? outerItem.receivableOrgName : this.model.data.form.sellerName;
    },
    // 显示账号信息
    accountVisible() {
      if (!this.dicCodeValue.payment_class) {
        return false;
      }
      return this.form.tradeMethod !== this.dicCodeValue.payment_class.cash;
    },
    copyInfo() {
      /**
       * 账户名称
       * 银行账户
       * 开户行
       * 转账备注
       * 付款金额
       */
      const ret = {};
      const {
        buyerAccount,
        sellerAccount,
        // 转账金额
        totalAmount,
      } = this.form;

      // 账户名称
      ret.accountName = this.form.sellerName;

      // 付款人
      ret.buyerAccount = buyerAccount;
      // 收款人
      ret.sellerAccount = sellerAccount;

      // 付款金额
      ret.totalAmount = totalAmount;

      // 转账备注
      ret.remark = this.paymentCode.slice(-6);

      const sellerItem = this.sellerAccountList.find(item => item.depositNumber === this.form.sellerAccount);
      if (sellerItem) {
        // 开户行
        const bank = this.dicCodeName.bank_branch[sellerItem.bankCode] || sellerItem.bankName;

        const {
          // 支行
          depositBank,
          // 银行账号
          depositNumber,
        } = sellerItem;

        // 银行账户
        ret.account = depositNumber;
        // 开户行
        ret.bank = `${bank}${depositBank}`;
      }
      return ret;
    },
    // 是否编辑
    isEdit() {
      return this.model.type === 'edit';
    },
  },
  data() {
    return {
      bizType: 'fms.trade.certificate',
      form: {
        // 收款方
        sellerName: '',
        // 收款方账号
        sellerAccount: '',
        // 交易方式 payment_class
        tradeMethod: '',
        // 付款方
        buyerName: '',
        // 付款方账号
        buyerAccount: '',
        // 交易日期
        tradeFinishTime: '',
        // 交易金额
        totalAmount: '',
        // 交易凭证
        // tradeResult: '',
        // 摘要
        tradeCode: '',
        tradeId: '',
      },
      transactionReceipt: [],
      addBankModel: {},
      addBankVisible: false,
      sellerAccountList: [],
      buyerAccountList: [],
      updateFileds: [],
      updateFiledsModal: {},
      updateFiledsVisible: false,
    };
  },
  methods: {
    onUpdateFieldConfirm(data) {
      this.$setFormatData(this.form, data);
    },
    toChangeField() {
      // 'buyerAccount' 付款方账户, 'sellerAccount' 收款方账户,
      // 'totalAmount' 付款金额, 'tradeFinishTime 付款日期'

      // 如果 transactionReceipt 为空,则只修改：收款方账户，付款金额
      // else 修改：收款方账户，付款金额，付款方账户，付款日期
      if (this.transactionReceipt.length) {
        this.updateFileds = ['buyerAccount', 'sellerAccount', 'totalAmount', 'tradeFinishTime'];
      } else {
        this.updateFileds = ['sellerAccount', 'totalAmount'];
      }

      this.updateFiledsModal = {
        title: this.$t('apip_step21_xin_xi_geng_gai'),
        data: this.form,
      };

      this.updateFiledsVisible = true;
    },
    onConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (this.transactionReceipt.length) {
          await this.$refs.transactionReceipt.submit();
        }
        if (valid) {
          this.closeDialog();
          this.$emit(this.model.type, this.getEmitData());
        }
      });
    },
    getEmitData() {
      // 收款方（卖方）
      const sellerItem = this.sellerAccountList.find(item => item.depositNumber === this.form.sellerAccount);
      // 付款方（买方）
      const buyerItem = this.buyerAccountList.find(item => item.depositNumber === this.form.buyerAccount);
      const ret = { ...this.form };

      if (buyerItem) {
        ret.buyerBank = buyerItem.depositBank;
      }
      if (sellerItem) {
        ret.sellerBank = sellerItem.depositBank;
      }

      ret.attachs = this.transactionReceipt;

      ret.buyerId = this.payableOrgId;
      ret.sellerId = this.receivableOrgId;
      ret.buyerTradeRemark = this.copyInfo.remark;
      ret.tradeMethod = this.dicCodeValue.payment_class.public_account;

      return ret;
    },
    onCopy() {
      const copyInfo = this.copyInfo;
      const ret = [
        // 账户名称
        `${this.$t('apip_step21_zhmc_1')}${copyInfo.accountName}`,
        // 银行账户
        `${this.$t('apip_step21_yhzh_1')}${copyInfo.account}`,
        // 开户行
        `${this.$t('apip_step21_kai_hu_hang')}${copyInfo.bank}`,
        // 转账备注
        `${this.$t('apip_step21_zzbz_1')}${copyInfo.remark}`,
        // 付款金额
        `付款金额：${'￥'}${copyInfo.totalAmount}`,
      ];

      this.$copyToClip(ret.join('\r\n'));
    },
    onAddBankSuccess() {
      this.$refs.bank.getSelectList();
    },
    getRemark(str) {
      if (str && str.length) {
        return str.slice(-6);
      }
      return '';
    },
    onBuyerAccountGetList(list) {
      this.buyerAccountList = list;
      if (this.form.buyerAccount) {
        return;
      }
      const item = list.find(obj => obj.isDefault);
      if (item) {
        this.form.buyerAccount = item.depositNumber;
      }
    },
    // 格式化银行列表数据，使label为：账号/银行/支行
    bankListFilter(list) {
      list.forEach((item) => {
        const depositBank = item.depositBank;
        const depositNumber = item.depositNumber;
        item.label = [depositNumber, depositBank].join('/');
      });
      return list;
    },
    onSellerAccountGetList(list) {
      this.sellerAccountList = list;
      if (this.form.sellerAccount) {
        return;
      }
      const item = list.find(obj => obj.isDefault);
      if (item) {
        this.form.sellerAccount = item.depositNumber;
      }
    },
    closeDialog() {
      this.visible = false;
    },
    init() {
      const form = this.model.data.form;
      const type = this.model.type || 'add';
      this.form.buyerName = this.buyerName;
      this.form.sellerName = this.sellerName;
      this.form.tradeCode = this.orderNum;
      if (type === 'edit') {
        this.$setFormatData(this.form, form);
        this.form.tradeMethod = String(this.form.tradeMethod);
        if (form.attachs && form.attachs.length) {
          this.transactionReceipt = form.attachs;
        }
        if (this.form.totalAmount) {
          this.form.totalAmount = String(this.form.totalAmount);
        }
      } else {
        // this.form.tradeMethod = this.dicCodeValue.payment_class.public_account;
        if (form.tradeMethod) {
          this.form.tradeMethod = form.tradeMethod;
        }
        if (this.totalAmount) {
          this.form.totalAmount = String(this.totalAmount);
        }
      }
      // 默认银行转账
      if (!this.form.tradeMethod) {
        this.form.tradeMethod = this.dicCodeValue.payment_class.public_account;
      }
    },
    addBank() {
      this.addBankModel = {
        type: 'add',
        title: this.$t('apip_step21_xzyh'),
      };
      this.addBankVisible = true;
    },
  },
  mounted() {
    this.mergeLanguage(null, 'portal_add_pay_info_public_step2_dialog');
    // this.getLanguage();
    this.getDictionaryCodeName('bank_branch');
    this.getDictionaryCodeValue('payment_class', () => {
      this.init();
      // dicCodeValue
      // public_account 对公转账
      // cash 现金
    });
  },

  beforeCreate() {},
};
</script>

<style lang="scss">
.add-pay-info-public-step2-dialog {
  .el-dialog .el-dialog__body .el-form-item__label {
    padding-bottom: 0;
  }
  .row {
    position: relative;
    .el-form-item__content {
      position: static;
    }
    .item {
      line-height: 17px;
      height: 17px;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 100;
      cursor: pointer;
      color: #00a0d9;
      .label {
        float: left;
        padding-left: 5px;
        font-size: 12px;
        text-decoration: underline;
      }
    }
  }
  .content {
    display: flex;
    .l {
      flex: 1;
      width: 0;
      padding-right: 24px;

      .group {
        &:nth-child(n + 2) {
          margin-top: 24px;
        }
        > .title {
          font-size: 12px;
          line-height: 17px;
          color: #202945;
          font-weight: bold;
        }

        > .info {
          padding-top: 16px;
          .pay-type {
            overflow: hidden;

            .item {
              height: 48px;
              width: 100%;
              text-align: center;
              line-height: 48px;
              background: #f8f8f8;
              border-radius: 8px;
              box-shadow: 0 0 0 1px rgba(245, 245, 245, 1) inset;
              position: relative;
              overflow: hidden;
              cursor: pointer;

              .tag-checked {
                display: none;
              }

              &.checked {
                background: rgba(0, 160, 217, 0.16);
                box-shadow: 0 0 0 1.5px #00a0d9 inset;

                .label {
                  color: #202945;
                }
                .tag-checked {
                  display: block;
                  position: absolute;
                  top: 0;
                  right: 0;
                  width: 30px;
                  height: 24px;
                  font-size: 24px;
                  line-height: 24px;
                  color: #00a0d9;
                }
              }
              .tag {
                font-size: 15px;
                color: #00a0d9;
              }
              .label {
                padding-left: 10px;
                font-size: 14px;
                color: #4d4d4d;
              }
            }
          }
        }
      }
    }
    .r {
      width: 361px;
      padding: 24px;

      .info-preview {
        width: 100%;
        overflow: hidden;
        border-radius: 4px;
        border: 1px solid rgba(245, 245, 245, 1);
        border-top: 4px solid #00a0d9;

        padding: 24px 24px 32px 24px;

        > .title {
          font-size: 14px;
          line-height: 20px;
          font-weight: bold;
          color: #202945;
        }

        > .list {
          margin-top: 24px;
          .item {
            overflow: hidden;
            line-height: 21px;
            font-size: 14px;
            &:nth-child(n + 2) {
              margin-top: 8px;
            }
            .key {
              float: left;
              color: #4d4d4d;
            }
            .val {
              overflow: hidden;
              word-break: break-all;
              padding-left: 16px;
              color: #1a1a1a;
            }
            .tips {
              color: #eb5a5a;
            }
          }
        }

        .amount {
          overflow: hidden;
          line-height: 24px;
          margin-top: 24px;
          .key {
            color: #4d4d4d;
            font-size: 14px;
            float: left;
          }
          .val {
            padding-left: 18px;
            float: left;
            color: #00a0d9;
            font-size: 18px;
            font-weight: bold;
          }
        }

        .copy {
          width: 100%;
          margin-top: 24px;
          span {
            padding-left: 6px;
          }
        }
      }
    }
  }
}
</style>
